import 'react-datepicker/dist/react-datepicker.css';
import ptBR from 'date-fns/locale/pt-BR';
import { registerLocale } from 'react-datepicker';

registerLocale('ptBR', ptBR);

export const datePicker = {
  '.react-datepicker-wrapper': {
    display: 'block',
    width: '100%',
  },
  '.react-datepicker': {
    fontFamily: 'unset',
    fontSize: '0.9rem',
    padding: '0.75rem',
    border: '1px solid white !important',
    borderRadius: '12px !important',
    boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
  },
  '.react-datepicker__month-container .react-datepicker__header': {
    backgroundColor: 'white',
    border: 'none',
    paddingBottom: '0',
    paddingTop: '0',
    marginTop: '5px',
    fontWeight: 600,
  },
  '.react-datepicker__day-names': {
    paddingTop: '0.25rem',
    paddingBottom: '0.25rem',
  },
  '.react-datepicker__day-names .react-datepicker__day-name': {
    color: 'gray',
    fontSize: '0.85rem',
    fontWeight: 400,
  },
  '.react-datepicker__week': { fontSize: '0.9rem' },
  '.react-datepicker__navigation--previous': {
    marginTop: '15px',
    marginLeft: '5px',
  },
  '.react-datepicker__navigation--next': {
    marginTop: '15px',
    marginRight: '5px',
  },
  '.react-datepicker__day, .react-datepicker__day--keyboard-selected:hover': {
    color: 'white',
  },
  '.react-datepicker__day, .react-datepicker__month-text, .react-datepicker__quarter-text, .react-datepicker__year-text':
    {
      color: '#212121',
    },
  '.react-datepicker__day--outside-month': {
    color: 'lightgrey !important',
    pointerEvents: 'none',
  },
  '.react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range, .react-datepicker__month-text--in-range, .react-datepicker__quarter-text--in-range, .react-datepicker__year-text--in-range), .react-datepicker__month-text--in-selecting-range:not(.react-datepicker__day--in-range, .react-datepicker__month-text--in-range, .react-datepicker__quarter-text--in-range, .react-datepicker__year-text--in-range), .react-datepicker__quarter-text--in-selecting-range:not(.react-datepicker__day--in-range, .react-datepicker__month-text--in-range, .react-datepicker__quarter-text--in-range, .react-datepicker__year-text--in-range), .react-datepicker__year-text--in-selecting-range:not(.react-datepicker__day--in-range, .react-datepicker__month-text--in-range, .react-datepicker__quarter-text--in-range, .react-datepicker__year-text--in-range)':
    {
      backgroundColor: 'lightgray',
    },
  '.react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range, .react-datepicker__month-text--in-range, .react-datepicker__quarter-text--in-range, .react-datepicker__year-text--in-range)':
    {
      backgroundColor: '#9dcac2',
      color: 'white',
    },
  '.react-datepicker__current-month, .react-datepicker-time__header, .react-datepicker-year-header':
    {
      marginTop: '0',
      color: '#212121',
      fontWeight: 500,
    },
  '.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::after': {
    display: 'none',
  },
  '.react-datepicker__triangle': { display: 'none' },
  '.react-datepicker-popper': { paddingTop: '5px', zIndex: 1500 },
  '.react-datepicker__header__dropdown--scroll': {
    color: 'gray',
    paddingTop: '12px',
    display: 'flex',
    justifyContent: 'flex-end',
    paddingBottom: '8px',
    fontWeight: 600,
  },
  '.react-datepicker__year-dropdown, .react-datepicker__year-dropdown--scrollable': {
    backgroundColor: 'white !important',
    boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px !important',
    border: '1px solid #f1f1f1 !important',
    left: '51% !important',
  },
  '.react-datepicker__month-dropdown': {
    backgroundColor: 'white !important',
    boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px !important',
    border: '1px solid #f1f1f1 !important',
    left: '51% !important',
  },
  '.react-datepicker__.current-month, .react-datepicker__.current-month--hasYearDropdown, .react-datepicker__current-month--hasMonthDropdown':
    {
      color: '#212121',
      fontFamily:
        "'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif",
      opacity: 0.9,
      textTransform: 'capitalize',
    },
  '.react-datepicker__day--selected, .react-datepicker__day--in-selecting-range, .react-datepicker__day--in-range, .react-datepicker__month-text--selected, .react-datepicker__month-text--in-selecting-range, .react-datepicker__month-text--in-range, .react-datepicker__quarter-text--selected, .react-datepicker__quarter-text--in-selecting-range, .react-datepicker__quarter-text--in-range, .react-datepicker__year-text--selected, .react-datepicker__year-text--in-selecting-range, .react-datepicker__year-text--in-range':
    {
      borderRadius: '0.3rem',
      backgroundColor: '#9dcac2',
      color: '#fff !important',
      border: 'none !important',
    },
  '.react-datepicker__month-read-view--down-arrow, .react-datepicker__year-read-view--down-arrow': {
    right: '-16px',
    top: '0',
    transform: 'rotate(135deg) translate(0, -50%)',
  },
  '.react-datepicker__day--keyboard-selected, .react-datepicker__month-text--keyboard-selected, .react-datepicker__quarter-text--keyboard-selected, .react-datepicker__year-text--keyboard-selected':
    {
      backgroundColor: '#cfe5e1 !important',
    },
  '.react-datepicker__day--disabled': {
    color: 'gray.300',
  },
  '.react-datepicker__close-icon::after': {
    bg: '#9dcac2',
  },
};
